import { secured } from '../plugins/axios';

const resource = '/businesses/admin/';

export default {
    getTags: params => secured.get(`${resource}tags/`, { params }),
    createTag: data => secured.post(`${resource}tags/`, data),
    updateTag: (id, data) => secured.put(`${resource}tags/${id}/`, data),
    deleteTag: id => secured.delete(`${resource}tags/${id}/`),

    parkingOptions: params => secured.get(`${resource}parking-options/`, { params }),
    serviceOptions: params => secured.get(`${resource}service-options/`, { params }),
    facilityOptions: params => secured.get(`${resource}facility-options/`, { params }),
    goodForOptions: params => secured.get(`${resource}good-for-options/`, { params }),
    mealOptions: params => secured.get(`${resource}meal-options/`, { params }),
    foodOptions: params => secured.get(`${resource}food-options/`, { params }),
};
